/**
 * zod's jitless mode for every zod copy on the DP shell page (plan
 * 2026-10-03-shell-ui-csp-root-shell-ci-pg, D-1). A side-effect module: import it first, before
 * any module that builds a zod schema. It exports nothing.
 *
 * Why. The DP gateway sends a report-only CSP, `default-src 'self'`, with no `'unsafe-eval'`. zod 4
 * makes two kinds of `Function` call. It probes `new Function("")` once, at the first `z.object`
 * construction. It also compiles a fast parser per object schema at that schema's first parse. The
 * policy reports each call, even though zod catches the probe's throw. With `jitless: true` zod makes
 * neither call and uses its interpreted parser.
 *
 * Order. zod reads `jitless` when it constructs each object schema, and not when it parses. A schema
 * that a module built before this module ran keeps its compiled fast path. So the boot entry
 * (`cloud/dp/shell/src/boot/entry.ts`) and the system-surfaces bundle entry (`src/index.tsx`) import
 * this module first.
 *
 * Scope. From zod 4.4.0, zod keeps its config on one `globalThis` object that every zod copy of
 * 4.4.0 or later shares (`globalThis.__zod_globalConfig`). So this call also covers the copies
 * inside the system-surfaces bundle and a hosted app bundle on zod 4.4.0 or later that loads after
 * it. zod 4.0.0 to 4.3.x keep a module-local config, so this call does not reach a hosted app
 * bundle on those versions. Such an app must call `z.config({ jitless: true })` itself. The call
 * only sets one key; it reads nothing and has no other side effect.
 */
import { z } from 'zod';

z.config({ jitless: true });
